import { InfoBlock } from 'app/components/commons/InfoBlock/InfoBlock';
import type { CustomerDataResponse } from 'app/typings/core/admin/bookings/booking';

type Props = {
  customer: CustomerDataResponse;
};

export const Contact = ({ customer }: Props) => (
  <InfoBlock
    title="Contact"
    rows={[
      { label: 'E-mail', value: customer.email },
      { label: 'Tel', value: customer.phone },
    ]}
  />
);
